import React, { FC, useEffect, useMemo, useState } from 'react';
import { BhiFormDialog, Button } from 'src/UIKit';
import { FormView } from 'src/components/FormPart/FormView';
import { FormErrorRecord } from 'src/components/FormPart/types';
import { CreateKeywordFormDialogController } from '../../controllers';
import { KeywordFormData } from '../../types';
import { CreateKeywordForm } from './CreateKeywordForm';

interface CreateKeywordFormDialogProps extends CreateKeywordFormDialogController {}

const FORM_ID = 'keyword-form';

export const CreateKeywordFormDialog: FC<CreateKeywordFormDialogProps> = (props) => {
  const { isOpen, close, initFormData, error, submit } = props;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [keywordName, setKeywordName] = useState(initFormData?.name ?? '');

  useEffect(() => {
    setKeywordName(initFormData?.name ?? '');
  }, [initFormData]);

  const errorList: FormErrorRecord<KeywordFormData>[] | undefined = useMemo(() => {
    if (error?.error === 'conflict') {
      return [{ field: 'name', message: 'Entity with this name already exists' }];
    }
  }, [error]);

  return (
    <BhiFormDialog
      isOpen={isOpen}
      onClose={close}
      title={initFormData?.id ? 'Update Keyword' : 'Create Keyword'}
      compactSpacing
      actions={
        <Button
          type="submit"
          form={FORM_ID}
          variant="contained"
          disabled={isSubmitting || !keywordName.trim()}
        >
          {initFormData?.id ? 'Update' : 'Create'}
        </Button>
      }
    >
      {initFormData && (
        <FormView
          formId={FORM_ID}
          formData={initFormData}
          component={CreateKeywordForm}
          componentProps={{ onNameChange: setKeywordName }}
          errorList={errorList}
          onSubmit={async (full, dirty) => {
            setIsSubmitting(true);
            try {
              await submit(full, dirty);
            } finally {
              setIsSubmitting(false);
            }
          }}
        />
      )}
    </BhiFormDialog>
  );
};
